module.exports = __webpack_public_path__ + "img/download-android.87a7052a.png";